module.exports = __webpack_public_path__ + "media/images/basic-logos/empty-cart-68d5493100c21fc115a279d7294d146d.png";